export default "__VITE_ASSET__f187d295__"